import { useState, useEffect } from 'react'
import {Pagination} from 'antd'
import useStore from 'base/store'
import {PROJECT_CATEGORY_NAME, ProjectCategory} from 'modules/project'
import {Loader} from 'common/components'
import {maybePluralize} from 'common/helpers'
import {
  ProjectsList,
  ProjectsListPanel,
  useGet1PageProjects,
  uniqueUsersFromProjects,
  uniqueBorrowersFromProjects,
  ProjectFilterItems,
  ProjectsProps,
} from '..'
import { ProjectsStatsNew } from './ProjectsStats.new'

export default function CurrentProjects() {
  return (
    <>
      <ProjectsStatsNew />
      <Projects // projects={projects}
      />
    </>
  )
}

const Projects = ({projects = []}: ProjectsProps) => {
  const [pageNumber, setPageNumber] = useState(1)
  const role = useStore((state) => state.role)
  const filter = useStore((state) => state.currentProjectsFilter)
  const search = useStore((state) => state.currentProjectsSearch)
  const sort = useStore((state) => state.currentProjectsSort)
  const setFilter = useStore((state) => state.setCurrentProjectsFilter)
  const setSearch = useStore((state) => state.setCurrentProjectsSearch)
  const setSort = useStore((state) => state.setCurrentProjectsSort)
  const querySort = sort
    .replace('maturity', 'maturityDate')
    .replace('desc', '-')
    .replace('asc', '')
    .replace(' ', '')
  // console.log(querySort)
  const {data, isRefetching} = useGet1PageProjects({
    sort: querySort,
    filter,
    search: search.trim(),
    pageNumber,
  })

  const filteredProjects: any[] | undefined = data?.data
  const currentProjects = filteredProjects || [] // ? filteredProjects : projects

  useEffect(() => {
    /**
      Senario:
        there are 100 projects in tatol
        and end use set the page number as 7
        and then, end user input search key words
        let us assume the search result includes 3 valid results
        but because the latest page number is 7
        so, page 7 result list is empty
      In this case:
        let us go back to page 1
     */
    if (
      (!!filteredProjects) &&
      (filteredProjects.length === 0) &&
      (!!search) &&
      (!!data?.meta?.total)
    ) {
      setPageNumber(1)
    }
  })

  const regionsSet = new Set<string>(
    projects.map((project: any) => project.region)
  )

  const allCategories = projects.map((project: any) => project.categories)
  const categoriesSet = new Set<ProjectCategory>(allCategories.flat())

  const filterItems: ProjectFilterItems = {
    region: Array.from(regionsSet).map((region) => ({
      value: region,
      label: region,
    })),
    category: Array.from(categoriesSet).map((category) => ({
      value: category,
      label: PROJECT_CATEGORY_NAME[category],
      tip: maybePluralize(
        allCategories.reduce(
          (count, categories) =>
            categories.includes(category) ? count + 1 : count,
          0
        ),
        'project'
      ),
    })),
    borrower: uniqueBorrowersFromProjects(projects).map((borrower) => ({
      value: borrower.uuid,
      label: `${borrower.firstName} ${borrower.lastName}`,
      tip: borrower.displayId,
      image: borrower.photo,
    })),
    manager: role.manager
      ? undefined
      : uniqueUsersFromProjects(projects, 'manager').map((manager) => ({
          value: manager.uuid,
          label: `${manager.firstName} ${manager.lastName}`,
          tip: manager.displayId,
          image: manager.photo,
        })),
  }

  return (
    (!filteredProjects) ? <Loader />
    :
    <>
      <ProjectsListPanel
        type="current"
        projectsCount={data.meta.total}
        filter={filter}
        filterItems={filterItems}
        search={search}
        setFilter={setFilter}
        setSearch={setSearch}
      />
      <ProjectsList
        isRefetching={isRefetching}
        type="current"
        sort={sort}
        items={currentProjects}
        setSort={setSort}
      />
      <Pagination
        showSizeChanger={false}
        current={pageNumber}
        total={data?.meta?.total || 1}
        pageSize={10}
        onChange={setPageNumber}
      />
    </>
  )
}
